// extracted by mini-css-extract-plugin
module.exports = {"Clicker":"Clicker_Clicker__3DBwV","clicker-spin":"Clicker_clicker-spin__30cZB","ClickerNumberDisplay":"Clicker_ClickerNumberDisplay__15mHZ"};